import { useRef, useState } from "react";
import { TipoProcesso } from "../../types/tipoProcesso/TipoProcesso";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import useTipoProcessoFetch from "./useTipoProcessoFetch";


type Props = {
    isdisabled?: boolean;
    isLoading?: boolean;
    required?: boolean;
    value?: TipoProcesso;
    handleSearchChange: (newValue: TipoProcesso) => void;
};

const TxtTipoProcesso = ({
    isdisabled,
    isLoading,
    required = false,
    value,
    handleSearchChange,
}: Props) => {


    const timeoutRef = useRef<number | null>(null);
    const loading = useRef(false);

    const handleSetLoad = (newValue: boolean) => {
        loading.current = newValue;
    };

    const [inputValue, setInputValue] = useState("");
    const { options } = useTipoProcessoFetch({ inputValue, handleSetLoad });


    return (
        <Autocomplete
            disabled={isdisabled}
            value={value}
            size="small"
            options={options}


            getOptionLabel={(option) => {
                const tipoProcesso = option as TipoProcesso;
                return tipoProcesso.nome ? tipoProcesso.nome : "";
            }}
            loading={loading.current}

            onInputChange={(event, newInputValue) => {

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = window.setTimeout(() => {
                    setInputValue(newInputValue);


                }, 700); // 300ms delay
            }}

            onChange={(event, newValue) => {
                handleSearchChange(newValue as TipoProcesso);
            }}

            onBlur={() => {
                // Verifica se o valor digitado corresponde a uma das opções
                if (!value || !options.some(option => option.nome === value.nome)) {
                    setInputValue(""); // Limpa o campo se não for uma opção válida

                   
                }
            }}

            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Tipo Processo"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading.current ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}

        />
    );








}
export default TxtTipoProcesso;

